import { AfterViewInit, Component, forwardRef, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import * as momentZone from 'moment-timezone';
import { FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

export class TZone {
  name: string;
  nameValue: string;
  timeValue: string;
  group: string;
  abbr: string;
}

export interface SelectConfig {
  appearance: 'underline' | 'outline';
  appendTo: string;
  clearOnBackspace: boolean;
  closeOnSelect: boolean;
  dropdownPosition: 'auto' | 'bottom' | 'top';
  hideSelected: boolean;
}

@Component({
  selector: 'timezone-picker',
  template: `
    <div class="wrapper" [formGroup]="form">
        <ng-select
            [formControlName]="formControlName"
            [items]="timeZones"
            [clearable]="clearable"
            [virtualScroll]="virtualScroll"
            [groupBy]="'group'"
            bindLabel="name"
            [placeholder]="customPlaceholderText"
            [notFoundText]="customNotFoundText"
            [appearance]="config.appearance"
            [appendTo]="config.appendTo"
            [clearOnBackspace]="config.clearOnBackspace"
            [closeOnSelect]="config.closeOnSelect"
            [dropdownPosition]="config.dropdownPosition"
            [hideSelected]="config.hideSelected">
        </ng-select>
    </div>
  `,
  styleUrls: [ './timezone-picker.component.scss' ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimezonePickerComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class TimezonePickerComponent implements OnInit, AfterViewInit, OnDestroy {

  /**
   * Setup section.
   */
  @Input() getUserZone = false;
  @Input() customPlaceholderText = '';
  @Input() customNotFoundText = 'No zone found';
  @Input() clearable = false;
  @Input() virtualScroll = true;
  @Input() disabled = false;
  @Input() formControlName = 'timezone';
  @Input() form: FormGroup;

  @Input()
  set config(conf: SelectConfig) {
    this._config = conf;
  }

  private _config: SelectConfig = {
    hideSelected: false,
    dropdownPosition: 'auto',
    appearance: 'underline',
    clearOnBackspace: true,
    closeOnSelect: true,
    appendTo: null
  };

  get config(): SelectConfig {
    return this._config;
  }

  /**
   * Internals section.
   */
  timeZones: Array<TZone>;
  private propagateChange: (_: any) => {};
  private destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.timeZones = momentZone.tz.names().map((zone: string) => this.formatZone(zone));
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Make TZone object from simple string.
   * @link ngOnInit
   */
  formatZone(zone: string): TZone {
    const utc: string = momentZone.tz(zone).format('Z');
    const abbr: string = momentZone.tz(zone).zoneAbbr();
    return {
      name: `${zone}`,
      nameValue: zone,
      timeValue: utc,
      group: zone.split('/', 1)[0],
      abbr: abbr
    };
  }

  /**
   * Propagate result to parent component.
   */
  private fireChanges() {
    if (this.propagateChange) {
      this.propagateChange(this.form.get(this.formControlName).value);
    }
  }

  /**
   * Clear selection.
   */
  private clearZone() {
    // this.form.get(this.formControlName).setValue(null);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  /**
   * Handle parent model value changes.
   */
  writeValue(zone: string | TZone): void {
    if (zone) {
      let _zone: TZone = null;

      if (typeof zone === 'string' && zone.length > 0) {
        _zone = this.timeZones.find(z => z.nameValue === zone);
      } else if (typeof zone === 'object') {
        _zone = this.timeZones.find(z => z.nameValue === zone.nameValue);
      }

      if (_zone) {
      }

    } else {
      // this.clearZone();
    }
  }

}
